import React from 'react'
import { NavLink } from 'redux-first-router-link'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'
import type { TableCellProps } from 'components/shared/Table/types'

import styles from './PrimaryCell.module.scss'

type PrimaryCellProps = Pick<
  TableCellProps,
  'maxWidth' | 'hasIncreasedHeight'
> & {
  description?: React.ReactNode
  primary?: React.ReactNode
  to?: React.ComponentProps<typeof NavLink>['to'] | null
}

export const PrimaryCell = ({
  description,
  maxWidth = '20rem',
  primary,
  to,
  hasIncreasedHeight,
}: PrimaryCellProps) => {
  return (
    <Table.Cell type="body" {...{ maxWidth, hasIncreasedHeight }}>
      <Box
        className={styles.content}
        direction="column"
        justify="center"
        tagName="span"
      >
        {to != null ? (
          <NavLink className={styles.link} to={to}>
            {primary}
          </NavLink>
        ) : (
          <span className={styles.text}>{primary}</span>
        )}
        {description && (
          <span className={styles.description}>{description}</span>
        )}
      </Box>
    </Table.Cell>
  )
}
